import { DeviceScreenSize, footerConstants } from '../../constants';
import isMobileDisplay from "../mobile/check";
export const footerTransitions = () => {
    if (typeof CSS !== 'undefined' && CSS.supports('interpolate-size: allow-keywords')) {
        // If the browser supports interpolate-size, we can rely on CSS for smooth transitions and skip JS animations
        return;
    }
    ;
    const animateAccordion = (content, opening) => {
        const fullHeight = content.scrollHeight;
        const heightAnimation = content.animate([
            { height: opening ? '0px' : `${fullHeight}px` },
            { height: opening ? `${fullHeight}px` : '0px' },
        ], { duration: footerConstants.detailsOpeningAnimationDurationMs, easing: footerConstants.detailsAnimationType });
        const opacityAnimation = content.animate([
            { opacity: opening ? '0' : '1' },
            { opacity: opening ? '1' : '0' },
        ], { duration: footerConstants.detailsOpacityAnimationDurationMs, easing: footerConstants.detailsAnimationType });
        return { heightAnimation, opacityAnimation };
    };
    document.querySelectorAll('footer details').forEach((details) => {
        const summary = details.querySelector('summary');
        const content = details.querySelector('[data-footer-accordion-content]');
        if (!summary || !content)
            return;
        let currentAnimations = null;
        summary.addEventListener('click', (e) => {
            if (!isMobileDisplay(DeviceScreenSize.Tablette))
                return;
            e.preventDefault();
            currentAnimations?.heightAnimation.cancel();
            currentAnimations?.opacityAnimation.cancel();
            if (details.open) {
                // Close
                const animations = animateAccordion(content, false);
                currentAnimations = animations;
                animations.heightAnimation.onfinish = () => {
                    details.removeAttribute('open');
                    content.style.height = '';
                    content.style.visibility = 'hidden';
                };
                animations.heightAnimation.oncancel = () => {
                    content.style.height = '';
                };
            }
            else {
                // Open
                details.setAttribute('open', '');
                content.style.visibility = 'visible';
                const animations = animateAccordion(content, true);
                currentAnimations = animations;
                animations.heightAnimation.onfinish = () => {
                    content.style.height = '';
                };
                animations.heightAnimation.oncancel = () => {
                    content.style.height = '';
                };
            }
        });
    });
};
